import { driver } from "driver.js";
import "driver.js/dist/driver.css";

/**
 * Onboarding tour per le 3 dashboard di categoria (iter51).
 *
 * Uso:
 *   import { runCategoryTour } from "./dashboards/tour";
 *   runCategoryTour(dashboardType, { onFinish: () => api.patch(...) });
 *
 * Il caller è responsabile di persistere il flag `tour_completed_dashboard`
 * su backend/User dopo che l'utente ha completato o chiuso il tour, così che
 * non venga ripetuto ad ogni ingresso.
 */

const COMMON = {
  showProgress: true,
  progressText: "{{current}} di {{total}}",
  nextBtnText: "Avanti →",
  prevBtnText: "← Indietro",
  doneBtnText: "Fatto! ✓",
  overlayColor: "#0f172a",
  overlayOpacity: 0.55,
  popoverClass: "housetag-tour-popover",
};

const STEPS_BY_TYPE = {
  tecnica: [
    {
      element: '[data-testid="dashboard-tecnica-sanatorie"]',
      popover: { title: "🏗 Pratiche in sanatoria", description: "Qui vedrai a colpo d'occhio tutte le sanatorie in corso con le loro scadenze di sanzione e emissione titolo." },
    },
    {
      element: '[data-testid="dashboard-tecnica-scia"]',
      popover: { title: "📋 SCIA & CILA", description: "Monitora i titoli abilitativi depositati: tempi di risposta del Comune ed eventuali richieste di integrazione." },
    },
    {
      element: '[data-testid="dashboard-tecnica-sopralluoghi"]',
      popover: { title: "🧭 Sopralluoghi programmati", description: "Timeline dei tuoi prossimi rilievi in cantiere con esito e allegati preparati per la relazione." },
    },
    {
      element: '[data-testid="dashboard-tecnica-urgenti"]',
      popover: { title: "🚨 Notifiche urgenti", description: "Radar sulle pratiche con scadenza entro 72h — così non ti sfugge nessun intervento prioritario." },
    },
  ],
  notaio: [
    {
      element: '[data-testid="dashboard-notaio-atti-attesa"]',
      popover: { title: "📜 Atti in attesa di stipula", description: "Vedrai qui gli atti calendarizzati con evidenza dei documenti ancora mancanti." },
    },
    {
      element: '[data-testid="dashboard-notaio-visure"]',
      popover: { title: "🔍 Visure & ispezioni", description: "Coda operativa delle visure ipocatastali richieste e delle ispezioni ancora da evadere." },
    },
    {
      element: '[data-testid="dashboard-notaio-scadenze"]',
      popover: { title: "⏰ Scadenze fiscali", description: "Reminder per registrazione telematica e trascrizione presso i registri immobiliari." },
    },
    {
      element: '[data-testid="dashboard-notaio-analisi"]',
      popover: { title: "📊 Analisi economica", description: "Onorari lordi, imposte trasferite e proventi netti dello studio in un colpo d'occhio." },
    },
  ],
  agenzia: [
    {
      element: '[data-testid="dashboard-agenzia-vendite"]',
      popover: { title: "📈 Analisi vendite", description: "Andamento delle vendite chiuse per mese, con confronto anno precedente e obiettivi commerciali." },
    },
    {
      element: '[data-testid="dashboard-agenzia-trattative"]',
      popover: { title: "🤝 Trattative aperte", description: "Funnel offerte → proposte accettate → preliminari firmati, con il conversion rate del tuo team." },
    },
    {
      element: '[data-testid="dashboard-agenzia-lead"]',
      popover: { title: "🎯 Lead & richieste", description: "Da dove arrivano i nuovi contatti (portali, sito, passaparola) e tempi medi di primo contatto." },
    },
    {
      element: '[data-testid="dashboard-agenzia-provvigioni"]',
      popover: { title: "💶 Provvigioni", description: "Provvigioni maturate del mese, in attesa di rogito e proiezione trimestrale." },
    },
  ],
};

export function runCategoryTour(dashboardType, { onFinish } = {}) {
  const steps = STEPS_BY_TYPE[dashboardType];
  if (!steps || steps.length === 0) return;
  // Filtra step i cui elementi non sono in pagina (defensive per test/preview)
  const validSteps = steps.filter(s => document.querySelector(s.element));
  if (validSteps.length === 0) return;
  const d = driver({
    ...COMMON,
    steps: validSteps,
    onDestroyed: () => {
      // Firing sia su "Fatto" che su "chiudi con X". Il caller persiste il flag.
      if (typeof onFinish === "function") onFinish();
    },
  });
  // Piccolo delay per lasciare al DOM il tempo di renderizzare i data-testid
  setTimeout(() => d.drive(), 250);
}
